export default __webpack_public_path__ + "static/media/lights.bab1e269.png";